import "primeicons/primeicons.css";
import "./main.css";
import "./assets/primevue/tailwind.css";
import "@fontsource/open-sans";

import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import App from "./App.vue";
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";
import router from "./router";
import ToastService from "primevue/toastservice";

import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export const app = createApp(App);
app.use(router);
app.use(createPinia());
app.use(PrimeVue, {
  theme: {
    preset: definePreset(Aura, {
      semantic: {
        primary: {
          50: "#f0f9ff",
          100: "#e0f2fe",
          200: "#bae6fd",
          300: "#7dd3fc",
          400: "#38bdf8",
          500: "#0ea5e9",
          600: "#0284c7",
          700: "#0369a1",
          800: "#075985",
          900: "#0c4a6e",
          950: "#082f49",
        },
      },
    }),
    options: {
      prefix: "p",
      cssLayer: {
        name: "primevue",
        importOrder: ["theme-light.css", "@import"],
        order: "theme-light.css, tailwind-base, primevue, tailwind-utilities",
      },
      darkModeSelector: "none",
    },
  },
});
app.use(ToastService);

app.component("FontAwesomeIcon", FontAwesomeIcon);

library.add(fas);

app.mount("#app");
